<script>
  import {supabase} from './supabaseClient';

  let loading = false
  let email;
  let password;
  let message = '';
  let messageType = ''; // 'error' or 'success'

  function clearMessageOnInput() {
    message = '';
  }

  function isValidEmail() {
    return email && email.trim() !== '' && email.indexOf('@') !== -1;
  }

  const sendResetPasswordLink = async () => {
    try {
      loading = true;
      message = '';
      if (!isValidEmail()) {
        message = 'Please enter a valid email address.';
        messageType = 'error';
        return;
      }
      const { data, error } = await supabase.auth.resetPasswordForEmail(
        email
      );
      if (error) throw error;
      message = `Check your email ${email} for the password reset link.`;
      messageType = 'success';
    } catch (error) {
      message = error.error_description || error.message;
      messageType = 'error';
    } finally {
      loading = false
    }
  }

  const login = async () => {
    try {
      loading = true;
      message = '';
      if (!isValidEmail()) {
        message = 'Please enter a valid email address.';
        messageType = 'error';
        return;
      }
      if (password == null || password.trim() === '') {
        message = 'Please enter your password.';
        messageType = 'error';
        return;
      }
      const { data, error } = await supabase.auth.signIn({
        email,
        password
      })
      if (error) {throw error};
    } catch (error) {
      message = error.error_description || error.message;
      messageType = 'error';
    } finally {
      loading = false
    }
  }

  const sendMagicLink = async () => {
    try {
      loading = true;
      message = '';
      if (!isValidEmail()) {
        message = 'Please enter a valid email address.';
        messageType = 'error';
        return;
      }
      const { error } = await supabase.auth.signIn({ email })
      if (error) {throw error};
      message = 'Check your email for the login link!';
      messageType = 'success';
    } catch (error) {
      message = error.error_description || error.message;
      messageType = 'error';
    } finally {
      loading = false
    }
  }

  let showingLoginSection = true;
  let arrowStates = [
    '--->',
    '----'
  ];
  let arrowState = 0;
  let arrow = arrowStates[0];

  //Change arrow every x seconds
  setInterval(() => {
    arrowState = (arrowState + 1) % arrowStates.length;
    arrow = arrowStates[arrowState];
  }, 800);
</script>
  
<div id="auth-container" class="font-life-savers-regular">
  <div id="auth-card">
    <form class="row flex flex-center" on:submit|preventDefault={login}>
      <div>
        <h1 class="header font-life-savers-extrabold">The Wallet</h1>
        <h2 class="description">Save links, save text.</h2>
          {#if showingLoginSection}
            <div class="beta-text">
              We are now in Private Beta! <br>
              Request access at <a id="email" href="mailto:dav.is@zohomail.in">dav.is@zohomail.in</a>.
            </div>
            <div class="divider">-----orrr-----</div>
            <div class="login-title">
              Already a Beta user? Sign in
            </div>
            <div id="inputs">
              <!-- svelte-ignore a11y-autofocus -->
              <input class="inputField" type="email" placeholder="Your email" bind:value={email} on:input={clearMessageOnInput} autofocus/>
              <input class="inputField" type="password" placeholder="Your password" bind:value={password} on:input={clearMessageOnInput}/>
              <button id="login-btn" type="submit" disabled={loading}> {loading ? "Loading..." : "Login"}  </button>
              {#if message}
                <div class="message {messageType}">{message}</div>
              {/if}
              <button type="button" on:click={sendResetPasswordLink} id="forgot-password" disabled={loading}>Forgot password?</button>
              <!-- <span class="divider">-----orrr-----</span>
              <button on:click|preventDefault={sendMagicLink}>Get a one-time login link to your email instead</button> -->
            </div>
          {:else}
            <div id="testimonial">
              <h4>
                What our customers have to say.
              </h4>
              <div class="testimonial-entry">
                <div class="testimonial-text">
                  "I louve the Wallit! The best i have everr used in my life. <s>...can i have the candy now?</s>"
                </div>
                <div class="testimonial-person">
                  - Ruth, 6 years old
                </div>
              </div>

              <div class="testimonial-entry">
                <div class="testimonial-text">
                  "Deserves its position in the visionary quadrant <s>for MEDIOCRITY</s>. How did they even get here?"
                </div>
                <div class="testimonial-person">
                  - Official Gartner <sub>belt</sub> reviews
                </div>
              </div>

              <div class="testimonial-entry">
                <div class="testimonial-text">
                  "<s>So bad. Who even</s> uses this, <s>let alone</s> everyday. I'll give it a 9 <s>out of 100</s>"
                </div>
                <div class="testimonial-person">
                  - Paul, New York Times <s>reader</s>
                </div>
              </div>
            </div>
          {/if}
        <div id="card-footer">
          <button id="switch-footer" on:click|preventDefault={() => {showingLoginSection = !showingLoginSection}}>
            {#if showingLoginSection}
              What our users have to say! <span class="font-monospace">{arrow}</span>
            {:else}
              Sign in already! <span class="font-monospace">{arrow}</span>
            {/if}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<style>
  .testimonial-entry {
    margin: 1rem auto;
    background-color: rgba(255, 255, 255, 0.1);
    padding: 0.7rem;
    border-radius: 9px;
    max-width: 35rem;
  }
  .testimonial-text {
    font-style: italic;
    text-align: left;
  }
  .testimonial-person {
    text-align: right;
    font-size: 0.9rem;
    margin-top: 0.2rem;
  }
  s {
    opacity: 0.6;
  }

  form {
      color: white;
  }
  * {
    box-sizing: border-box;
  }

  #auth-container {
    font-family: monospace;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(29, 0, 0);

    --s: 100px; /* control the size */
  
  --_g: #0000 90deg,#366 0;
  background: 
    conic-gradient(from 90deg at 2px 2px,var(--_g)),
    conic-gradient(from 90deg at 1px 1px,var(--_g));
  background-size: var(--s) var(--s), calc(var(--s)/5) calc(var(--s)/5);
  }

  #auth-card {
    width: max-content;
    height: max-content;
    margin: 1em auto 0em;
    padding: 3em 4em 1em 4em;
    border-radius: 1em;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.575);
    font-size: 1.4em;
  }

  .header {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-size: 3em;
    margin: 0em;
  }
  .description {
    margin: 0px;
  }
  .login-title {
    font-style: italic;
  }
  input {
    padding: 1em;
    font-size: 0.7em;
    margin: 0.2em;
    border: red;
  }
  #inputs {
    max-width: 60%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .inputField {
    min-width: 20rem;
    border: 5px solid #366;
  }
  .inputField:focus {
    outline: none;
    border: 5px solid rgb(81, 160, 160);
  }
  ::placeholder {
    font-family: monospace;
  }

  button {
    background-color: rgb(81, 160, 160);
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0.5em;
  }
  #login-btn {
    font-size: 1.3em;
  }

  #email:link {
    color: rgb(179, 215, 255);
  }

  #forgot-password {
    all: unset;
    cursor: pointer;
    color: rgb(179, 215, 255);
    font-size: 0.8em;
    margin: 0.5em 0;
  }
  #forgot-password:hover, #forgot-password:focus {
    text-decoration: underline;
  }
  #forgot-password:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .divider {
    font-size: 0.8em;
    font-style: italic;
    padding: 1em;
    opacity: 0.7;
    margin: 1rem;
  }

  .beta-text {
    background-color: black;
    padding: 1em;
    border-radius: 1em;
    border: 2px solid var(--rare-highlight);
    box-shadow: 0 0 10px var(--rare-highlight);
    margin-top: 2em;
    font-style: italic;
    font-size: 0.8em;
  }

  #card-footer {
    display: flex;
    justify-content: right;
    width: 100%;
    position: relative;
    right: -2em;
  }

  button#switch-footer {
    all: unset;
    cursor: pointer;
    margin-top: 2rem;
    background-color: rgb(24, 48, 48);
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
    text-align: right;
  }
  button#switch-footer:focus {
    outline: revert;
  }

  .message {
    width: 100%;
    padding: 0.5em;
    margin-top: 1em;
    border-radius: 5px;
    font-size: 0.8em;
    text-align: center;
  }
  .message.success {
    background-color: #2b5a2b;
    color: white;
  }
  .message.error {
    background-color: #722f2f;
    color: white;
  }

  @media screen and (max-width: 966px) {
    #auth-card {
      padding: 1em 2em 2em 2em;
    }
    #inputs {
      max-width: 80%;
    }
  }
</style>
